// extracted by mini-css-extract-plugin
module.exports = {"ticker-text":"TickerText_ticker-text__ccYeU","tickerText":"TickerText_ticker-text__ccYeU"};